import React, { Component } from 'react';
import { asyncComponent } from 'react-async-component';

const EmbedStateOperator = asyncComponent({
  resolve: () => import('./EmbedStateOperator'),
});

export default class EmbedStateWrapper extends Component {
  render() {
    return(
      <div>
        <EmbedStateOperator/>
      </div>
    );
  }
}
